import {
  Category,
  CustomPricingConfig,
  WHATSAPP_PRICING,
} from '@heltarchat/shared';

import { AdminBusiness } from './types';

// ============================================
// Constants
// ============================================

export const TABLE_HEIGHT = 'calc(var(--app-height, 100vh) - 340px)';

// ============================================
// Date Utilities — moved to `utils/dateRange` for reuse outside admin.
// Re-exported here so existing relative imports keep working.
// ============================================

export {
  MONTHS,
  getYearOptions,
  getDefaultPreviousMonth,
  getMonthDateRange,
} from 'utils/dateRange';

// ============================================
// Formatting Utilities
// ============================================

export const formatDate = (value: string | Date) =>
  new Date(value).toLocaleDateString('en-IN', {
    timeZone: 'Asia/Kolkata',
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });

export const formatCurrency = (
  amount: number,
  currency: string = '₹',
): string => {
  return `${currency}${amount.toFixed(2)}`;
};

export const formatBizWhatsapp = (business: AdminBusiness) => {
  if (!business.bizWhatsappNumber) return '—';
  return business.countryCode
    ? `+${business.countryCode} ${business.bizWhatsappNumber}`
    : business.bizWhatsappNumber;
};

// ============================================
// Pricing Utilities
// ============================================

export const DEFAULT_INDIA_PRICING = WHATSAPP_PRICING['IN'];

export const formatPrice = (
  customPrice: number | null | undefined,
  defaultPrice: number,
): string => {
  if (customPrice !== null && customPrice !== undefined) {
    return `${customPrice.toFixed(4)}`;
  }
  return `${defaultPrice.toFixed(4)} (default)`;
};

/** Extract a category price from a customPricing JSONB object */
export const getCountryPrice = (
  customPricing: CustomPricingConfig | null | undefined,
  isoCode: string,
  category: Category,
): number | undefined => {
  return customPricing?.[isoCode]?.[category];
};
